import { useState, } from "react";
import { X, Loader2, ChevronDown } from "lucide-react";
function MultiSelectDropdown({ label, options, selected, onChange, error, placeholder, loading, required = true }) {
  const [open, setOpen] = useState(false);

  const toggle = (id) =>
    onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);

  const selectedLabels = options
    .filter((o) => selected.includes(o.id))
    .map((o) => o.name)
    .join(", ");

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      
      {selectedLabels && (<>
       <span className={` text-sm mb-2 text-gray-800`}>
      <span className="font-medium"> Selected  {label} </span> :  {loading ? "Loading..." : selectedLabels || placeholder}
        </span>
      
      </>)}
      <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        disabled={loading}
        className={`w-full h-7 px-3 py-2 text-sm border rounded-md text-left flex justify-between items-center bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 ${error ? "border-red-400 bg-red-50" : "border-gray-300"
          } ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
      >
        <span className={`truncate text-gray-400`}>
          {loading ? "Loading..." : placeholder}
        </span>
        {loading ? (
          <Loader2 size={14} className="animate-spin text-gray-400" />
        ) : (
          <ChevronDown
            size={14}
            className={`ml-2 flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
          />
        )}
      </button>

      {open && !loading && (
        <div className="absolute z-[300] mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-auto">
          {options.length === 0 ? (
            <div className="px-4 py-2 text-sm text-gray-400">No options available</div>
          ) : (
            options.map((opt) => (
              <label
                key={opt.id}
                className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-blue-50 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(opt.id)}
                  onChange={() => toggle(opt.id)}
                  className="rounded text-blue-500 focus:ring-blue-400"
                />
                <span>{opt.name}</span>
              </label>
            ))
          )}
        </div>
      )}


      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
}

export default MultiSelectDropdown